module.exports = __webpack_public_path__ + "static/dance-2-d536120492c3f85fdeaf474638d5ab9c.gif";